import { render, staticRenderFns } from "./CityRank.vue?vue&type=template&id=3f42a271&scoped=true"
import script from "./CityRank.vue?vue&type=script&lang=js"
export * from "./CityRank.vue?vue&type=script&lang=js"
import style0 from "./CityRank.vue?vue&type=style&index=0&id=3f42a271&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f42a271",
  null
  
)

export default component.exports